// test1660
(1660 && 0);
